/*
    Function to get decoded node name
*/
export const getDecodedNodeName = (node) => {
    return node ? decodeURIComponent(node.split('@')[0]) : '';
};
